var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefit2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.516,
    height: 23.474,
    viewBox: "0 0 18.516 23.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5935",
    "data-name": "Group 5935",
    transform: "translate(-265.758 -1483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89811",
    "data-name": "Path 89811",
    d: "M27.327,67.337c5.031.721,6.337,3.677,6.337,7.215H15.85c0-3.538,1.306-6.495,6.337-7.215a3.01,3.01,0,0,0,5.139,0Z",
    transform: "translate(250.258 1431.922)",
    fill: "#5476ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89812",
    "data-name": "Path 89812",
    d: "M38.452,29.031a5.5,5.5,0,1,1-8.067,0,32.162,32.162,0,0,0,4.033.238A32.162,32.162,0,0,0,38.452,29.031Z",
    transform: "translate(240.597 1460.237)",
    fill: "#5476ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89813",
    "data-name": "Path 89813",
    d: "M42.6,21.239v1.34a32.17,32.17,0,0,1-4.034.238,32.169,32.169,0,0,1-4.034-.238v-1.34l2.816.651a5.165,5.165,0,0,0,2.435,0Z",
    transform: "translate(236.448 1465.996)",
    fill: "#5476ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89814",
    "data-name": "Path 89814",
    d: "M14.707,6.958l7.839-1.813a5.165,5.165,0,0,1,2.435,0l7.839,1.813a.26.26,0,0,1,0,.507L31.2,7.84v3.236l.873,1.512a.439.439,0,0,1-.759.44l-.114-.2v.227a.44.44,0,0,1-.88,0v-.227l-.114.2a.439.439,0,1,1-.759-.44l.873-1.512V8.044L24.98,9.278a5.166,5.166,0,0,1-2.435,0L14.707,7.465a.26.26,0,0,1,0-.507Z",
    transform: "translate(251.253 1478)",
    fill: "#5476ff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit2);
export default __webpack_public_path__ + "static/media/Benefit_2.6cf41e88dc2ab057fb5a6916f7a7686a.svg";
export { ForwardRef as ReactComponent };